import apiFetch from '../apiFetch'

export default function (token, dossierId, isHistorical) {
  return apiFetch({ endPoint: `paperworkType?dossierId=${dossierId}&dossierIsHistorical=${isHistorical}`, method: 'GET', token: token })
}
